"use strict";
// Media queries for mobile first design.
// Just override styles as the page gets larger.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DESKTOP_WIDE = exports.DESKTOP = exports.TABLET_LANDSCAPE = exports.TABLET_PORTRAIT = exports.MOBILE_LANDSCAPE = void 0;
// X-Small devices (portrait phones, less than 576px)
// No media query for `xs` since this is the default
// Small devices (landscape phones, 576px and up)
exports.MOBILE_LANDSCAPE = '(min-width: 576px)';
// Medium devices (tablets (portrait), 768px and up)
exports.TABLET_PORTRAIT = '(min-width: 768px)';
// Large devices (tablets (lanescape), small desktops, 992px and up)
exports.TABLET_LANDSCAPE = '(min-width: 992px)';
// Large devices (desktops, 992px and up)
exports.DESKTOP = '(min-width: 1200px)';
// XX-Large devices (larger desktops, 1400px and up)
exports.DESKTOP_WIDE = '(min-width: 1400px)';
